import {Pipe, PipeTransform} from '@angular/core';

/**
 * Renders a value's unit as a suffix, spaced off the number unless the unit reads better glued to
 * it (`%`). An empty/absent unit renders nothing, so a template can append it unconditionally.
 */
@Pipe({
  name: 'formatUnit'
})
export class FormatUnitPipe implements PipeTransform {
  /** Units attached to the number without a space. */
  private readonly attachedUnits = ['%'];

  transform(unit: string | null | undefined): string {
    if (!unit) {
      return '';
    }

    return this.attachedUnits.includes(unit.trim().toLowerCase()) ? unit : ` ${unit}`;
  }
}
